import React, {Component, Fragment} from 'react';
import connect from "react-redux/es/connect/connect";
import {Card, CardBody, CardText, CardTitle, Form, FormGroup, Input, Label, Button, Spinner} from "reactstrap";
import {Link} from "react-router-dom";
import {resetPassword} from "../../actions/auth";
import {RESET_PASSWORD} from "../../actions/types";
import Navbar from "../common/navbar/Navbar";
import HeroSection from "../common/HerroSection/hero-section";

class ResetPassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            password: '',
            errors: ''
        };
    }

    componentDidMount() {
        document.title = "Reset-password | Prime Private Network";
    }

    onChange = e => this.setState({[e.target.name]: e.target.value});
    handleChangePasswordValidation = () => {
        let fields = this.state;
        let errors = {};
        let formIsValid = true;

        if (fields.password.length === 0) {
            formIsValid = false;
            errors.password = "Password must be Required!";
        }
        if (fields.password.length < 8) {
            formIsValid = false;
            errors.new_password = "Password must be 8 character Long!";
        }
        /* else if (fields.password !== fields.new_password) {
                     formIsValid = false;
                     errors.new_password = "Password must be Same!";
                 }*/
        this.setState({errors: errors});
        return formIsValid;
    };

    onSubmitChangePassword = (e) => {
        e.preventDefault();
        if (this.handleChangePasswordValidation()) {
            const {password} = this.state;
            const userData = {
                user_id:this.props.match.params.userId,
                password:password,
            };
            this.props.resetPassword(userData,this.props.history);
            this.setState({
                password: '',
            });
        }
    };

    render() {
        const {errors} = this.state;
        return (
            <Fragment>
                <Navbar scenario={RESET_PASSWORD}/>
                <HeroSection title="Reset Password"/>
                <div className='auth-wrapper auth-v1 px-2'>
                    <div className='auth-inner py-2 '>
                        <Card className='mb-0 w-50 mx-auto mt-5 '>
                            <CardBody>
                                <CardTitle tag='h4' className='mb-1'>
                                    Reset Password?
                                </CardTitle>
                                <CardText className='mb-2'>
                                    password must be at least 8 characters long
                                </CardText>
                                <Form className='auth-forgot-password-form mt-2' autoComplete="off" noValidate={true}
                                      onSubmit={this.onSubmitChangePassword}>
                                    <FormGroup>
                                        <Label className='form-label' for='login-email'>
                                            New Password
                                        </Label>
                                        <Input type='password' name="password" id='password' value={this.state.password}
                                               onChange={this.onChange} placeholder='Enter New password'/>
                                        {errors.password && <span className='text-danger'>{errors.password}</span>}
                                    </FormGroup>
                                    {
                                        this.props.changePasswordLoader ?
                                            <button className="d-block btn btn-secondary mt-2">
                                                Loading....
                                            </button>
                                            :
                                            <button className="d-block btn btn-secondary mt-2">
                                                Reset Password
                                            </button>
                                    }
                                </Form>
                                <p className='text-center mt-2'>
                                    <Link to='/' className="text-secondary text-left row ml-2">
                                        <span className='align-middle'><i className="fa fa-arrow-left"
                                                                          aria-hidden="true"></i>Back to Home</span>
                                    </Link>
                                </p>
                            </CardBody>
                        </Card>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        resetPasswordLoader: state.auth.resetPasswordLoader,
        resetPassword: state.auth.resetPassword,

    };
};

export default connect(mapStateToProps, {resetPassword})(ResetPassword);


